import JwtService from '@/services/jwt.service'
import axios from '@/plugins/axios'

export default class DirectoryApiService {
  constructor() {
    this.setAuthHeader()
  }

  setAuthHeader() {
    const token = JwtService.getToken()
    axios.defaults.headers.common[import.meta.env.VITE_TOKEN_HEADER_KEY] = token ? `Bearer ${token}` : ''
  }

  async getOrgtypes() {
    const { data } = await axios.get('/v1/api_admin/directory/orgtypes')
    return data
  }

  async getPrograms() {
    const { data } = await axios.get('/v1/api_admin/directory/programs')
    return data
  }

  async getDirections() {
    const { data } = await axios.get('/v1/api_admin/directory/directions')
    return data
  }

  async getLevelsEducation() {
    const { data } = await axios.get('/v1/api_admin/directory/levels_education')
    return data
  }

  async getProgram(programId) {
    const { data } = await axios.get('/v1/api_admin/directory/programs/' + programId)
    return data
  }

  async saveProgram(params) {
    const { data } = await axios.post('/v1/api_admin/directory/programs/create', params)
    return data
  }

  async updateProgram(params) {
    const { data } = await axios.put('/v1/api_admin/directory/programs/update', params)
    return data
  }

  async getCity(cityId) {
    const { data } = await axios.get('/v1/api_admin/directory/cites/' + cityId)
    return data
  }

  async saveCity(params) {
    const { data } = await axios.post('/v1/api_admin/directory/cites/create', params)
    return data
  }

  async updateCity(params) {
    const { data } = await axios.put('/v1/api_admin/directory/cites/update', params)
    return data
  }

  async getArticleTag(tagId) {
    const { data } = await axios.get('/v1/api_admin/directory/articles/tags/' + tagId)
    return data
  }

  async saveArticleTag(params) {
    const { data } = await axios.post('/v1/api_admin/directory/articles/tags', params)
    return data
  }

  async updateArticleTag(tagId,params) {
    const { data } = await axios.put('/v1/api_admin/directory/articles/tags/'+tagId, params)
    return data
  }

  async getArticlesTags() {
    const { data } = await axios.get('/v1/api_admin/directory/articles/tags')
    return data
  }

  async getPopularTags() {
    const { data } = await axios.get('/v1/api_admin/directory/articles/tags/popular')
    return data
  }

  async searchTags(value) {
    const { data } = await axios.get('/v1/api_admin/directory/articles/tags/search?search=' + value)
    return data
  }

  async getTutorCategories() {
    const { data } = await axios.get('/v1/api_admin/directory/tutor_categories')
    return data
  }

  async getTutorCategory(categoryId) {
    const { data } = await axios.get('/v1/api_admin/directory/tutor_categories/' + categoryId)
    return data
  }

  async saveTutorCategory(params) {
    const { data } = await axios.post('/v1/api_admin/directory/tutor_categories', params)
    return data
  }

  async updateTutorCategory(categoryId, params) {
    const { data } = await axios.put('/v1/api_admin/directory/tutor_categories/' + categoryId, params)
    return data
  }

  async deleteTutorCategory(categoryId) {
    const { data } = await axios.delete('/v1/api_admin/directory/tutor_categories/' + categoryId)
    return data
  }
}
